<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <canal-cobro-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import CanalCobroCrud from "./CanalCobroCrud";
    export default {
        name: "CanalCobro",
        components: {CanalCobroCrud}
    }
</script>

<style scoped>

</style>

